// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__rlXew","cell":"ColumnAccessor_cell__34wDQ","firstCellAccent":"ColumnAccessor_firstCellAccent__3pYaD"};